import React from "react";
import { CalculatorV2ConfigurationModel } from "./models/calculator-configuration";
import { CalculatorStep } from "./models/CalculatorStep";
import { CalculatorTranslations } from "./models/CalculatorTranslations";
import CalculatorPage from "./views/pages/Calculator.Page";

type AppProps = {
  configuration: CalculatorV2ConfigurationModel;
  personaID: string;
  translations: CalculatorTranslations;
  apiUrl: string;
};

export default function App({
  configuration,
  personaID,
  translations,
  apiUrl,
}: AppProps) {
  return (
    <CalculatorPage
      config={configuration}
      personaID={personaID}
      translations={translations}
      apiUrl={apiUrl}
    />
  );
}
